const RUNTIME_KEY = '__EXPAI_API_URL__';

const readBase = (): string =>
  (
    ((globalThis as Record<string, any>)[RUNTIME_KEY] as string | undefined) ??
    (import.meta.env.VITE_API_URL as string | undefined)
  )?.replace(/\/$/, '') ?? '';

/** Snapshot at module load (kept for existing imports). Prefer getApiBaseUrl(). */
export const API_BASE_URL = readBase();

/** Current API base URL: follows /runtime-config.js reloads without a page refresh. */
export const getApiBaseUrl = (): string => readBase();

export const isExpaiApiEnabled = (): boolean => Boolean(getApiBaseUrl());

/**
 * Re-reads /runtime-config.js from the hosting (bypassing caches) and updates the
 * global API URL. Used when a request fails at network level: the API address may
 * have changed since the page was loaded. Returns true if the URL changed.
 */
export async function reloadRuntimeConfig(): Promise<boolean> {
  try {
    const res = await fetch(`/runtime-config.js?_=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return false;
    const m = /__EXPAI_API_URL__\s*=\s*["']([^"']+)["']/.exec(await res.text());
    if (!m) return false;
    const next = m[1].replace(/\/$/, '');
    const prev = readBase();
    (globalThis as Record<string, any>)[RUNTIME_KEY] = next;
    return next !== prev;
  } catch {
    return false;
  }
}
